/* mo-cart.js - unified cart drawer helpers (no Liquid inside) */
window.MO = window.MO || {};

(function() {
  // Money formatter
  function fmtMoney(cents) {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function' && window.MO && MO.moneyFormat) {
        return Shopify.formatMoney(cents, MO.moneyFormat);
      }
    } catch(e){}
    var value = (cents || 0) / 100;
    var parts = value.toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return parts[0] + ',' + parts[1] + ' €';
  }
  MO.fmtMoney = fmtMoney;

  /* ========= RADICAL CLICK BLOCKER (Priority 1) ========= */
  document.addEventListener('mousedown', function(e) {
    var row = e.target.closest('.is-personalized-locked');
    if (row) {
      if (e.target.closest('select, input, button, quantity-input, .quantity, .select-wrap')) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
      }
    }
  }, { capture: true });

  /* ========= API helpers ========= */
  function changeLineByIndex(lineIndex, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ line: lineIndex, quantity: quantity })
    }).then(function(r){ return r.json(); });
  }

  function changeByKey(lineKey, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    }).then(function(r){ return r.json(); });
  }

  /* ========= UI helpers ========= */
  function qsa(sel, root){ return Array.prototype.slice.call((root||document).querySelectorAll(sel)); }
  function qs(sel, root){ return (root||document).querySelector(sel); }
  function getRow(el){ return el && (el.closest('.myobs-cart__row') || el.closest('[id^="CartItem-"]') || el.closest('.cart-item')); }

  // --- FUNZIONE DI BLOCCO DISTRUTTIVA ---
  function lockPersonalizedRow(row) {
    if (!row) return;
    var isPersonalized = row.getAttribute('data-is-personalized') === 'true';
    if (!isPersonalized) {
       var textContent = row.textContent || "";
       isPersonalized = /Initials|Iniziali|initials/i.test(textContent);
    }
    
    if (isPersonalized) {
      row.classList.add('is-personalized-locked');
      var selects = row.querySelectorAll('select');
      selects.forEach(function(sel) {
          sel.value = "1";
          sel.setAttribute('disabled', 'disabled');
          sel.style.pointerEvents = 'none';
          for (var i = sel.options.length - 1; i >= 0; i--) {
             if (sel.options[i].value !== "1") sel.options[i].remove();
          }
      });
      var inputs = row.querySelectorAll('input[name="updates[]"], .quantity__input');
      inputs.forEach(function(input) {
          input.value = 1;
          input.setAttribute('readonly', 'readonly');
          input.setAttribute('disabled', 'disabled');
          input.style.pointerEvents = 'none';
      });
      row.querySelectorAll('button, .quantity__button, quantity-selector, .quantity__chevron').forEach(function(el) {
          if (!el.hasAttribute('data-remove-link') && !el.closest('cart-remove-button')) el.remove();
      });
      var qtyWrapper = row.querySelector('quantity-input, .quantity, .myobs-cart__quantity, .select-wrap');
      if (qtyWrapper) {
          qtyWrapper.style.pointerEvents = 'none';
          qtyWrapper.style.cursor = 'not-allowed';
      }
    }
  }

  // Show empty state
  function showEmptyState(cart) {
    softUpdateTotals(cart);
    var form = document.getElementById('cart');
    if (form) form.classList.add('critical-hidden');
    var cartItemsWrapper = document.querySelector('cart-items') || document.getElementById('main-cart-items') || document.querySelector('.myobs-cart');
    if (cartItemsWrapper) cartItemsWrapper.classList.add('is-empty');
    var list = document.querySelector('.myobs-cart__list');
    if (list) list.innerHTML = '';
    var empty = document.getElementById('mo-empty');
    if (empty) { empty.hidden = false; void empty.offsetWidth; empty.classList.add('is-visible'); }
    var otherOptions = document.querySelectorAll('.mo-otheroptions, .myobs-otheroptions, #mo-giftbox, .mo-giftbox');
    otherOptions.forEach(function(n){ n.style.display = 'none'; });
    var btn = document.getElementById('checkout') || document.querySelector('[data-checkout-button]') || document.querySelector('.cart__checkout, .cart__submit, .checkout-button');
    if (btn) btn.setAttribute('disabled', 'disabled');
  }

  function hideEmptyState() {
    var form = document.getElementById('cart');
    if (form) form.classList.remove('critical-hidden');
    var cartItemsWrapper = document.querySelector('cart-items') || document.getElementById('main-cart-items') || document.querySelector('.myobs-cart');
    if (cartItemsWrapper) cartItemsWrapper.classList.remove('is-empty');
    var empty = document.getElementById('mo-empty');
    if (empty) { empty.classList.remove('is-visible'); empty.hidden = true; }
    var otherOptions = document.querySelectorAll('.mo-otheroptions, .myobs-otheroptions, #mo-giftbox, .mo-giftbox');
    otherOptions.forEach(function(n){ n.style.display = ''; });
    var btn = document.getElementById('checkout') || document.querySelector('[data-checkout-button]') || document.querySelector('.cart__checkout, .cart__submit, .checkout-button');
    if (btn) btn.toggleAttribute('disabled', false);
  }

  function applyCartToUI(cart) {
    qsa('[data-cart-total]').forEach(function(n){ n.textContent = fmtMoney(cart.total_price); });
    qsa('[data-cart-subtotal]').forEach(function(n){ n.textContent = fmtMoney(cart.items_subtotal_price); });

    var btn = document.getElementById('checkout') || document.querySelector('[data-checkout-button]') || document.querySelector('.cart__checkout, .cart__submit, .checkout-button');
    if (btn) btn.toggleAttribute('disabled', cart.item_count === 0);

    cart.items.forEach(function(item, idx){
      var row = document.querySelector('[data-line-key="' + item.key + '"]');
      if (!row) {
        var lineIndex = idx + 1;
        var qtySelect = document.querySelector('.quantity__select[name="updates[]"][data-index="' + lineIndex + '"]') ||
                        document.querySelector('[name="updates[]"][data-index="' + lineIndex + '"]');
        if (qtySelect) row = getRow(qtySelect);
      }
      if (row) {
        var linePriceEl = row.querySelector('[data-line-price]') || row.querySelector('.cart-item__price-wrapper .price, .price--end');
        if (linePriceEl) linePriceEl.textContent = fmtMoney(item.final_line_price);
        var qtyInput = row.querySelector('input[name="updates[]"], .quantity__input');
        if (qtyInput && String(qtyInput.value) !== String(item.quantity)) qtyInput.value = item.quantity;
        lockPersonalizedRow(row);
      }
    });
    if (cart.item_count === 0) { showEmptyState(cart); } else { hideEmptyState(); }
  }
  MO.applyCartToUI = applyCartToUI;

  function finalizeUI(){
    qsa('#main-cart-items .cart-item__image-container').forEach(function(w){ w.classList.add('is-ready'); });
    qsa('.loading__spinner').forEach(function(s){ s.classList.add('hidden'); });
    var ci = document.querySelector('cart-items'); if (ci) ci.classList.remove('is-loading');
  }
  MO.finalizeUI = finalizeUI;

  /* ========= Soft remove helpers ========= */
  function softRemoveRow(row){
    if (!row) return;
    var h = row.getBoundingClientRect().height;
    row.style.height = h + 'px'; row.style.opacity = '1'; row.style.transform = 'translateY(0)'; row.style.overflow = 'hidden'; row.style.willChange = 'height, opacity, transform';
    var bez = 'cubic-bezier(.19,1,.22,1)';
    row.style.transition = 'height 1.2s '+bez+', opacity 0.55s ease, transform 1.2s '+bez+', margin 1.2s '+bez;
    requestAnimationFrame(function(){
      row.style.height = '0px'; row.style.opacity = '0'; row.style.transform = 'translateY(12px)'; row.style.marginTop = '0'; row.style.marginBottom = '0';
    });
    var done = false;
    var cleanup = function(){ if (done) return; done = true; if (row && row.parentNode) row.remove(); };
    row.addEventListener('transitionend', cleanup, { once:true });
    setTimeout(cleanup, 1400);
  }
  MO.softRemoveRow = softRemoveRow;

  function softUpdateTotals(cart){
    qsa('[data-cart-total]').forEach(function(n){ n.textContent = fmtMoney(cart.total_price); });
    qsa('[data-cart-subtotal]').forEach(function(n){ n.textContent = fmtMoney(cart.items_subtotal_price); });
    var btn = document.getElementById('checkout') || document.querySelector('[data-checkout-button]') || document.querySelector('.cart__checkout, .cart__submit, .checkout-button');
    if (btn) btn.toggleAttribute('disabled', cart.item_count === 0);
    var badge = document.querySelector('.myobsnum');
    if (badge) badge.textContent = '(' + cart.item_count + ')';
    var discUl = document.querySelector('.discounts[role="list"]');
    if (discUl) {
      discUl.innerHTML = '';
      (cart.cart_level_discount_applications || []).forEach(function(d){
        var li = document.createElement('li');
        li.className = 'discounts__discount discounts__discount--position';
        li.textContent = d.title + ' (-' + fmtMoney(d.total_allocated_amount) + ')';
        discUl.appendChild(li);
      });
    }
  }
  MO.softUpdateTotals = softUpdateTotals;

  function softReindexLines(){
    qsa('.quantity__select[name="updates[]"][data-index]').forEach(function(sel, i){
      var newIndex = String(i + 1);
      if (sel.dataset.index !== newIndex) sel.dataset.index = newIndex;
      var newId = 'Quantity-' + newIndex;
      if (sel.id !== newId) {
        var label = sel.closest('quantity-input') && sel.closest('quantity-input').querySelector('label[for]');
        if (label) label.setAttribute('for', newId);
        sel.id = newId;
      }
    });
    qsa('.myobs-cart__row,[id^="CartItem-"]').forEach(function(row, i){
      if (row.id && row.id.indexOf('CartItem-') === 0) row.id = 'CartItem-' + (i + 1);
    });
  }
  MO.softReindexLines = softReindexLines;

  /* ========= Change listener ========= */
  document.addEventListener('change', function(e){
    var t = e.target;
    if (!t.matches('[name="updates[]"], .quantity__input, .quantity__select')) return;
    
    var row = getRow(t);
    if (row && (row.classList.contains('is-personalized-locked') || row.getAttribute('data-is-personalized') === 'true')) {
       e.preventDefault(); e.stopPropagation();
       t.value = 1; 
       return;
    }

    e.preventDefault(); e.stopPropagation();
    var lineIndex = parseInt(t.dataset.index, 10);
    var qty = parseInt(t.value, 10);
    if (!lineIndex || isNaN(qty)) return;

    if (qty > 3) { qty = 3; t.value = '3'; }

    if (t._moTimer) clearTimeout(t._moTimer);
    t._moTimer = setTimeout(function(){
      var key = t.getAttribute('data-line-key') || (t.closest('[data-line-key]') && t.closest('[data-line-key]').getAttribute('data-line-key'));
      var req = key ? changeByKey(key, qty) : changeLineByIndex(lineIndex, qty);
      var unitPriceEl = row && row.querySelector('[data-unit-price]');
      var linePriceEl = row && (row.querySelector('[data-line-price]') || row.querySelector('.cart-item__price-wrapper .price, .price--end'));
      if (unitPriceEl && linePriceEl) {
        var unitCents = parseInt(unitPriceEl.getAttribute('data-unit-price'), 10);
        if (!isNaN(unitCents)) linePriceEl.textContent = fmtMoney(unitCents * qty);
      }
      req.then(function(cart){ applyCartToUI(cart); finalizeUI(); }).catch(function(){ finalizeUI(); });
      delete t._moTimer;
    }, 900);
  }, { capture: true });

  /* ========= MUTATION OBSERVER ========= */
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) { 
           if (node.matches && (node.matches('.myobs-cart__row') || node.matches('.cart-item'))) lockPersonalizedRow(node);
           if (node.querySelectorAll) {
               var rows = node.querySelectorAll('.myobs-cart__row, .cart-item, [id^="CartItem-"]');
               rows.forEach(lockPersonalizedRow);
           }
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });

  /* ========= MODAL RIMUOVI ARTICOLO CARRELLO ========= */
  var modal = document.getElementById('mo-remove-modal');
  var state = { key:null, row:null };

  function openModal(data){
    if (!modal) return;
    if (modal.parentNode !== document.body) document.body.appendChild(modal);
    document.body.classList.add('modal-open');
    state.key = data.key || null; state.row = data.row || null;
    var imgEl = modal.querySelector('.mo-modal__media img'); var nameEl = modal.querySelector('.mo-modal__name'); var varEl = modal.querySelector('.mo-modal__variant'); var priceEl = modal.querySelector('.mo-modal__price');
    if (imgEl){ imgEl.src = data.img || ''; imgEl.alt = data.name || ''; }
    if (nameEl){ nameEl.textContent = data.name || ''; }
    if (varEl){ varEl.textContent = data.variant || ''; }
    if (priceEl){ priceEl.textContent = (typeof data.cents === 'number') ? fmtMoney(data.cents) : (data.priceText || ''); }
    modal.classList.remove('is-closing'); modal.hidden = false; modal.setAttribute('aria-hidden','false');
    requestAnimationFrame(function(){ modal.classList.add('is-open'); });
  }

  function forceUnlockUI(){
    var ci = document.querySelector('cart-items'); if (ci) ci.classList.remove('is-loading');
    document.body.classList.remove('loading'); document.body.classList.remove('modal-open');
  }

  function closeModal(){
    if (!modal) return;
    modal.classList.remove('is-open'); modal.classList.add('is-closing');
    setTimeout(function(){ document.body.classList.remove('modal-open'); modal.classList.remove('is-closing'); modal.setAttribute('aria-hidden','true'); modal.hidden = true; state.key = null; state.row = null; }, 300);
  }

  window.MO_openRemoveModal = function(el, ev){
    try {
      if (ev) { ev.preventDefault(); ev.stopPropagation(); ev.stopImmediatePropagation(); }
      var row = el.closest('.myobs-cart__row') || el.closest('[id^="CartItem-"]') || el.closest('.cart-item');
      var key = el.getAttribute('data-line-key');
      if (!key) { try { var url = new URL(el.href, window.location.origin); key = url.searchParams.get('id'); } catch(_) {} }
      var name = (row && row.querySelector('.cart-item__name') ? row.querySelector('.cart-item__name').textContent.trim() : '') || el.getAttribute('data-item-name') || '';
      var img  = (row && row.querySelector('.cart-item__image') ? row.querySelector('.cart-item__image').src : '') || el.getAttribute('data-item-img') || '';
      var cents = parseInt(el.getAttribute('data-line-cents'), 10);
      var sizeText = '';
      var opts = row && row.querySelector('.myobs-cart__options');
      if (opts) { var firstDD = opts.querySelector('dd'); if (firstDD) sizeText = firstDD.textContent.trim(); }
      openModal({ key: key, row: row, name: name, img: img, cents: isNaN(cents) ? null : cents, variant: sizeText });
    } catch(e) { console.error('MO_openRemoveModal error', e); }
    return false;
  };

  document.addEventListener('click', function(e){
    var removeBtn = e.target.closest('[data-remove-link]');
    if (!removeBtn) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    MO_openRemoveModal(removeBtn, e);
  }, { capture: false });

  document.addEventListener('click', function(e){
    var confirmBtn = e.target.closest('#mo-remove-modal [data-mo-confirm]');
    if (!confirmBtn) return;
    e.preventDefault();
    if (!state.key || confirmBtn.dataset.busy) return;
    confirmBtn.dataset.busy = '1'; confirmBtn.disabled = true;
    changeByKey(state.key, 0).then(function(cart){
      if (state.row) softRemoveRow(state.row);
      softUpdateTotals(cart); softReindexLines();
      if (cart.item_count === 0) { showEmptyState(cart); }
      finalizeUI(); document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      closeModal();
    }).catch(function(){ closeModal(); forceUnlockUI(); location.reload(); })
      .finally(function(){ confirmBtn.disabled = false; delete confirmBtn.dataset.busy; });
  }, { capture: true });

  document.addEventListener('click', function(e){
    var cancel = e.target.closest('#mo-remove-modal [data-mo-cancel], #mo-remove-modal .mo-modal__backdrop');
    if (!cancel) return;
    e.preventDefault(); closeModal(); forceUnlockUI();
  }, { capture: true });

  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && modal && !modal.hidden) { closeModal(); forceUnlockUI(); } });
  document.addEventListener('DOMContentLoaded', finalizeUI);

  document.addEventListener('cart:updated', function(e){
    var cart = e.detail || {};
    if (cart.item_count === 0 && cart.attributes && cart.attributes['Gift message']) {
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'Gift message': '' } }) });
    }
    if (cart) softUpdateTotals(cart);
    if (cart.item_count === 0) { showEmptyState(cart); } else { hideEmptyState(); }
    applyCartToUI(cart); 
  });

  /* ========= MODAL REGALO (GIFT MESSAGE) ========= */
  (function(){
    var giftModal = document.getElementById('mo-gift-modal');
    var openBtn   = document.querySelector('[data-mo-gift-open]');
    if (!giftModal || !openBtn) return;
    
    var textarea   = giftModal.querySelector('#mo-gift-text');
    var countEl    = giftModal.querySelector('#mo-gift-count');
    var saveBtn    = giftModal.querySelector('[data-mo-gift-save]');
    var cancelEls  = giftModal.querySelectorAll('[data-mo-gift-cancel], .mo-modal__backdrop');
    var removeBtn  = giftModal.querySelector('[data-mo-gift-remove]');
    var statusEl   = giftModal.querySelector('#mo-gift-status');
    var subEl      = document.getElementById('mo-gift-subtitle');

    var defaultSubtitle = window.theme && window.theme.strings && window.theme.strings.addGiftMessage 
                          ? window.theme.strings.addGiftMessage 
                          : 'Aggiungi un biglietto personalizzato al tuo ordine';

    function openGiftModal(){
      if (giftModal.parentNode !== document.body) { document.body.appendChild(giftModal); }
      document.body.classList.add('modal-open'); 
      giftModal.hidden = false; 
      giftModal.setAttribute('aria-hidden', 'false'); 
      giftModal.classList.remove('is-closing');
      requestAnimationFrame(function(){ giftModal.classList.add('is-open'); });
      setTimeout(function(){ if(textarea) textarea.focus(); }, 200); 
      updateCount();
    }

    function closeGiftModal(){
      giftModal.classList.remove('is-open'); 
      giftModal.classList.add('is-closing');
      setTimeout(function(){ 
        document.body.classList.remove('modal-open'); 
        giftModal.classList.remove('is-closing'); 
        giftModal.hidden = true; 
        giftModal.setAttribute('aria-hidden','true'); 
        if (statusEl) statusEl.textContent = '';
      }, 500);
    }

    function updateCount(){ 
      if (!textarea || !countEl) return; 
      var len = (textarea.value || '').length;
      countEl.textContent = String(len); 
      
      if (removeBtn) {
        if (len === 0) {
          removeBtn.disabled = true;
          removeBtn.style.opacity = '0.4';
          removeBtn.style.cursor = 'not-allowed';
        } else {
          removeBtn.disabled = false;
          removeBtn.style.opacity = '1';
          removeBtn.style.cursor = 'pointer';
        }
      }
    }

    function updateGiftPreview(msg){ 
      if (!subEl) return; 
      var clean = (msg || '').trim(); 
      subEl.textContent = clean ? '"' + clean + '"' : defaultSubtitle; 
    }

    function saveGiftMessage(){
      if (!textarea) return; 
      var msg = (textarea.value || '').trim();
      if(saveBtn) saveBtn.disabled = true;

      fetch('/cart/update.js', { 
        method: 'POST', 
        headers: { 'Content-Type': 'application/json' }, 
        body: JSON.stringify({ attributes: { 'Gift message': msg } }) 
      })
      .then(function(r){ return r.json(); })
      .then(function(){ 
        updateGiftPreview(msg); 
        textarea.value = msg; 
        updateCount();
        if (statusEl) statusEl.textContent = msg === '' ? 'Messaggio rimosso.' : 'Messaggio salvato.';
        setTimeout(closeGiftModal, 300); 
      })
      .catch(function(){ 
        if (statusEl) statusEl.textContent = 'Errore di salvataggio. Riprova.'; 
      })
      .finally(function() {
        if(saveBtn) saveBtn.disabled = false;
      });
    }

    function clearAndCloseGiftMessage(){
      if (textarea) textarea.value = '';
      updateCount();
      
      fetch('/cart/update.js', { 
        method: 'POST', 
        headers: { 'Content-Type': 'application/json' }, 
        body: JSON.stringify({ attributes: { 'Gift message': '' } }) 
      })
      .then(function(){ 
        updateGiftPreview('');
        closeGiftModal(); 
      });
    }

    function removeMessageOnly() {
      if (textarea) {
        textarea.value = '';
        textarea.focus();
      }
      updateCount();
    }

    if (openBtn) openBtn.addEventListener('click', function(e){ e.preventDefault(); openGiftModal(); });
    if (saveBtn) saveBtn.addEventListener('click', function(e){ e.preventDefault(); saveGiftMessage(); });
    
    if (removeBtn) {
      removeBtn.addEventListener('click', function(e){ 
        e.preventDefault(); 
        removeMessageOnly(); 
      });
    }
    
    cancelEls.forEach(function(el){ 
      el.addEventListener('click', function(e){ e.preventDefault(); clearAndCloseGiftMessage(); }); 
    });
    
    document.addEventListener('keydown', function(e){ 
      if (e.key === 'Escape' && giftModal.classList.contains('is-open')) { 
        clearAndCloseGiftMessage(); 
      } 
    });
    
    if (textarea) textarea.addEventListener('input', updateCount);

  })();

})(); /* fine IIFE globale */